/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Test_Sound_MessageInputs */

const vi_station_test_sound_message = /** @type {(inputs: Station_Test_Sound_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đây là âm thanh thử loa của khu vực đóng hàng`)
};

/**

* @param {Station_Test_Sound_MessageInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_test_sound_message = /** @type {((inputs?: Station_Test_Sound_MessageInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Test_Sound_MessageInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_test_sound_message(inputs)
});